import React, { Component, Fragment } from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

class Overlay extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    return (
      <span className="d-inline-block mb-2 mr-2">
        <Modal
          isOpen={this.props.openOverlay}
          // toggle={this.props.closeOverlay}
          className={this.props.className}
        >
          <ModalHeader
            toggle={this.props.closeOverlay}
          >
            {this.props.title}
            {
              this.props.subTitle !== undefined &&
              <Fragment><br /><span className="subtitle">{this.props.subTitle}</span></Fragment>
            }
          </ModalHeader>
          <ModalBody>
            {this.props.children}
          </ModalBody>
          {
            this.props.data === true &&
            <ModalFooter>
              {this.props.data}
            </ModalFooter>
          }
        </Modal>
      </span>
    );
  }
}

export default Overlay;